import { Injectable, inject } from '@angular/core';
import {LorenDevice} from '../../interfaces/loren-device.interface';
import {LorenBaseCrudService} from '../../../../shared/services/loren-base-crud-service/loren-base-crud.service';
import {LorenDeviceEndpointsService} from '../loren-device-endpoints-service/loren-device-endpoints.service';

/**
 * @deprecated
 */
@Injectable({
    providedIn: 'root'
})
export class LorenDeviceService extends LorenBaseCrudService<LorenDevice> {
    protected lorenDeviceEndpointsService: LorenDeviceEndpointsService;


    constructor() {
        const lorenDeviceEndpointsService = inject(LorenDeviceEndpointsService);

        super(lorenDeviceEndpointsService.devices());

        this.lorenDeviceEndpointsService = lorenDeviceEndpointsService;
    }
}
